export const DATA_UPLOAD_GET_USE_CASES = 'DATA_UPLOAD_GET_USE_CASES'
export const DATA_UPLOAD_CONVERT = 'DATA_UPLOAD_CONVERT'
export const DATA_UPLOAD_START_CHUNKED = 'DATA_UPLOAD_START_CHUNKED'
export const DATA_UPLOAD_SEND_CHUNK = 'DATA_UPLOAD_SEND_CHUNK'
export const DATA_UPLOAD_GET_CHUNKED_STATUS = 'DATA_UPLOAD_GET_CHUNKED_STATUS'
export const DATA_UPLOAD_LIST_DRAFTS = 'DATA_UPLOAD_LIST_DRAFTS'
export const DATA_UPLOAD_GET_DRAFT_JOB = 'DATA_UPLOAD_GET_DRAFT_JOB'
export const DATA_UPLOAD_GET_DRAFT_TEMPLATE = 'DATA_UPLOAD_GET_DRAFT_TEMPLATE'
export const DATA_UPLOAD_GET_DRAFT = 'DATA_UPLOAD_GET_DRAFT'
export const DATA_UPLOAD_DELETE_DRAFT = 'DATA_UPLOAD_DELETE_DRAFT'
export const DATA_UPLOAD_SAVE_DRAFT_ANSWERS = 'DATA_UPLOAD_SAVE_DRAFT_ANSWERS'
export const DATA_UPLOAD_MARK_DRAFT_APPLIED = 'DATA_UPLOAD_MARK_DRAFT_APPLIED'
export const DATA_UPLOAD_GET_SUBJECT_ALIASES = 'DATA_UPLOAD_GET_SUBJECT_ALIASES'
export const DATA_UPLOAD_PUT_SUBJECT_ALIASES = 'DATA_UPLOAD_PUT_SUBJECT_ALIASES'
